import FormattedMessage from 'I18n/components/FormattedMessage';
import * as links from '../../../lib/links';
import { Link } from 'foundations-components/transitional/components/Link';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { InsertImageIcon } from 'foundations-assets/icons/components/InsertImageIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ViewToolbarAddLogo() {
  return /*#__PURE__*/_jsx(View, {
    borderRadius: "100",
    borderStyle: "dashed",
    borderWidth: "200",
    borderColor: "border-core-default",
    padding: "200",
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      gap: "200",
      children: [/*#__PURE__*/_jsx(Flex, {
        children: /*#__PURE__*/_jsx(InsertImageIcon, {
          size: "600",
          color: "icon-core-default"
        })
      }), /*#__PURE__*/_jsx(Link, {
        href: links.getBrandIdentityUrl(),
        external: true,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "view.toolbar.addLogo"
        })
      })]
    })
  });
}